import { Directive, input } from '@angular/core';

export const TextareaFormControlDirectiveInputs = ['rows'];

@Directive({
  selector: '[uiTextareaFormControl]',
  standalone: true,
})
export class TextareaFormControlDirective {
  readonly rows = input(4);
}
